export default __webpack_public_path__ + "static/aboutus3-091f17c7cabed4c475b4b6d8f80e91db.png";